import React from 'react';
import { Box, Stack, ButtonBase, useTheme } from '@mui/material';
import LightModeRoundedIcon from '@mui/icons-material/LightModeRounded';
import DarkModeRoundedIcon from '@mui/icons-material/DarkModeRounded';
import { useTranslation } from 'react-i18next';

import { useSettingsContext } from '../../../../setting/SettingsContext';
import SectionLabel from './SectionLabel';

const OPTIONS = [
    { value: 'light', icon: LightModeRoundedIcon, en: 'Light', ar: 'فاتح' },
    { value: 'dark', icon: DarkModeRoundedIcon, en: 'Dark', ar: 'داكن' },
];

const ModeOptions = () => {
    const theme = useTheme();
    const { i18n } = useTranslation();
    const isArabic = (i18n.language || 'en').startsWith('ar');

    const { themeMode, onChangeMode } = useSettingsContext();

    return (
        <Box>
            <SectionLabel>{isArabic ? 'الوضع' : 'Mode'}</SectionLabel>
            <Stack direction="row" spacing={1.5}>
                {OPTIONS.map(({ value, icon: Icon, en, ar }) => {
                    const selected = themeMode === value;
                    return (
                        <ButtonBase
                            key={value}
                            onClick={() => onChangeMode(value)}
                            sx={{
                                flex: 1,
                                flexDirection: 'column',
                                gap: 0.75,
                                p: 1.5,
                                borderRadius: 2,
                                border: `1.5px solid ${
                                    selected ? theme.palette.primary.main : theme.palette.divider
                                }`,
                                bgcolor: selected
                                    ? `${theme.palette.primary.main}12`
                                    : 'transparent',
                                color: selected ? theme.palette.primary.main : 'text.primary',
                                transition: 'all 0.2s',
                                '&:hover': {
                                    borderColor: theme.palette.primary.main,
                                    bgcolor: `${theme.palette.primary.main}08`,
                                },
                            }}
                        >
                            <Icon fontSize="small" />
                            <Box sx={{ fontSize: 12, fontWeight: 600 }}>
                                {isArabic ? ar : en}
                            </Box>
                        </ButtonBase>
                    );
                })}
            </Stack>
        </Box>
    );
};

export default ModeOptions;
